import React, { useState, useEffect } from 'react';

import { 
  ModelBase
} from "@models";
import { 
  TemplateBase, 
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function TemplateBaseEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<TemplateBase>(param_obj instanceof TemplateBase ? param_obj : api.applyWorkingOn(new TemplateBase()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <ModelBaseInput
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof TemplateBase) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}
    />
  );
}
